async function __CartChanged(event) {

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    setTimeout(()=>{      
      const atr = document.querySelector(".hidden_atr_div");
      var freeGiftId = parseInt(atr?.getAttribute('free_gift'));
      var freeGiftThreshold = atr?.getAttribute('freeGiftThreshold');
      var freeGiftValue = atr?.getAttribute('free_gift_value');
      var threshold_value = atr?.getAttribute('threshold_value');
      var cartTotal = cartContent.total_price ;
      var cart = cartContent;
      var giftInCart = false;
      if(freeGiftValue == 'true'){
        freeGiftValue = true;
      }else{
        freeGiftValue = false;
      }
      if(threshold_value == 'enabled'){
        threshold_value = true;
      }else{
        threshold_value = false;
      }
      // console.log(threshold_value);
      // console.log(freeGiftValue);
  
      Array.from(cart.items).find(item=>{
        if(item.id == freeGiftId){
          giftInCart = true;          
        }
      });

      const _currentURL = new URL(window.location.href);
      const _params = new URLSearchParams(_currentURL.searchParams);
      const _stringParam = _params.toString();
      const _has_klaviyoKey = _stringParam.includes('klaviyo_free_gift');

      if(_has_klaviyoKey) sessionStorage.setItem("has_free_gift", "true");

      const alreadyHaveFreeGift = Array.from(cart.items).some(item => item.id === freeGiftId && item.properties.hasOwnProperty('_abandoned_gift_product'));

      // console.log("test: ", Array.from(cart.items).some(item => item.line_level_total_discount === 0 && item.properties.hasOwnProperty('_welcome_series_klaviyo')));
                  
      var welcomeSeriesKlaviyoFreeGift = false;
                  
      if(sessionStorage.getItem("has_free_gift") == 'true'){
       welcomeSeriesKlaviyoFreeGift = Array.from(cart.items).some(item => Array.from(cart.items).some(item => item.properties.hasOwnProperty('_welcome_series_klaviyo'))); 
      }
      console.log(welcomeSeriesKlaviyoFreeGift);

      if(alreadyHaveFreeGift && cart.items.length > 1) return;
      
      // Check if the cart total price exceeds the threshold for free gift
      
      if (threshold_value && cartTotal >= freeGiftThreshold || welcomeSeriesKlaviyoFreeGift) {
        // Check if the free gift is not already in the cart
        if (!giftInCart) {
          var freeGift = {
            items: [
              {
                id: freeGiftId,
                quantity: 1
              }
            ]
          };
  
          // Make an AJAX request to add the free gift to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(freeGift)
          })
          .then(response => response.json())
          .then(data => {
            // console.log('Free gift added:', data);
            if(window.themeVariables.settings.pageType == 'cart'){
              window.location.href = `${Shopify.routes.root}cart`;
            } else{
              _onCartRefresh();
            }
            // location.reload(); // Reload the page to reflect changes in the cart
          })
          .catch(error => {
            console.error('Error adding free gift:', error);
          });
        }
      } else if(freeGiftValue == true && threshold_value == false || welcomeSeriesKlaviyoFreeGift){
        if (!giftInCart) {
          var freeGift = {
            items: [
              {
                id: freeGiftId,
                quantity: 1
              }
            ]
          };
  
          // Make an AJAX request to add the free gift to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(freeGift)
          })
          .then(response => response.json())
          .then(data => {
            // console.log('Free gift added:', data);
            if(window.themeVariables.settings.pageType == 'cart'){
              window.location.href = `${Shopify.routes.root}cart`;
            } else{
              _onCartRefresh();
            }
            // location.reload(); // Reload the page to reflect changes in the cart
          })
          .catch(error => {
            console.error('Error adding free gift:', error);
          });
        } else{
          //   if(giftInCart){
          //   // console.log(giftInCart);
            
          //   let updates = {
          //     [freeGiftId]: 0
          //   };
            
          //   fetch(window.Shopify.routes.root + 'cart/update.js', {
          //     method: 'POST',
          //     headers: {
          //       'Content-Type': 'application/json'
          //     },
          //     body: JSON.stringify({ updates })
          //   })
          //   .then(response => response.json())
          //   .then(data => {
          //     // console.log('Free gift removed:', data);
          //     this._onCartRefresh();
          //     // location.reload();
          //   })
          //   .catch((error) => {
          //     console.error('Error:', error);
          //   });
          // }
        }
      }else{
        if(giftInCart){
          // console.log(giftInCart);
          
          let updates = {
            [freeGiftId]: 0
          };
          
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(data => {
            // console.log('Free gift removed:', data);
            if(window.themeVariables.settings.pageType == 'cart'){
              window.location.href = `${Shopify.routes.root}cart`;
            } else{
              _onCartRefresh();
            }
            // location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      }
    }, 500);
    // __CartChanged();
    // const updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"][extractSectionId(this)], "text/html");
    // if (event.detail.cart["item_count"] > 0) {
    //   const currentLineItemsElement = this.querySelector(".cart-drawer__line-items"), updatedLineItemsElement = updatedDrawerContent.querySelector(".cart-drawer__line-items");
    //   if (!currentLineItemsElement) {
    //     this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
    //     UpdateCartComplementary();
    //   } else {
    //     setTimeout(() => {
    //       currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
    //       UpdateCartComplementary();
    //     }, event.detail.baseEvent === "variant:add" ? 0 : 1250);
    //     this.querySelector('[slot="footer"]').replaceChildren(...updatedDrawerContent.querySelector('[slot="footer"]').childNodes);
    //   }
    // } else {
    //   await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
    //   this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
    //   animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
    //   UpdateCartComplementary();
    // }
    // updateTotalPrice();
  }

__CartChanged();

window.solarflowerGiftSet = async function(){
  const CartDrawer = document.querySelector('cart-drawer');
  const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  setTimeout(()=>{    
    const solarflower_gift_set_data = document.querySelector('.solarflower_gift_set_data');
    if(solarflower_gift_set_data){
      const converted_html = new DOMParser().parseFromString(solarflower_gift_set_data.innerText, "text/html");
      const solarFlowerInput = converted_html?.querySelector('.solarflower_data_input');
      if(!solarFlowerInput) return;
      var solarGiftInCart = false;
      var solarFlowerGiftId = solarFlowerInput.getAttribute('data-solar-gift-id');
      var has_flower_product_in_cart = solarFlowerInput.getAttribute('data-has-solarflower-in-cart') == 'true';
      Array.from(cartContent.items).find(item=>{
        if(item.id == solarFlowerGiftId){
          solarGiftInCart = true;          
        }
      });
      if(has_flower_product_in_cart && solarGiftInCart) return;
      if(has_flower_product_in_cart && !solarGiftInCart){
        var SolarFreeGift = {
          items: [
            {
              id: solarFlowerGiftId,
              quantity: 1
            }
          ]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(SolarFreeGift)
        })
        .then(response => response.json())
        .then(data => {
          console.log('Solar Flower Free gift added:', data);
          if(window.themeVariables.settings.pageType == 'cart'){
            window.location.href = `${Shopify.routes.root}cart`;
          } else{
            CartDrawer._onCartRefresh();
          }
        })
        .catch(error => {
          console.error('Error adding free gift:', error);
        });
      }else{
        let updates = {
          [solarFlowerGiftId]: 0
        };
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Solar Flower Free gift Removed');
          if(window.themeVariables.settings.pageType == 'cart'){
            window.location.href = `${Shopify.routes.root}cart`;
          } else{
            CartDrawer._onCartRefresh();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    }
  }, 550);
}
window.solarflowerGiftSet();

(function () {
  const mountingOptionsInputs = document.querySelectorAll(
    ".input-mounting__options"
  );
  if (mountingOptionsInputs.length) {
    mountingOptionsInputs.forEach((input) =>
      input.addEventListener(
        "change",
        handleMountingInputChange.bind(this),
        true
      )
    );
  }

  function handleMountingInputChange(event) {
    const target = event.currentTarget;
    const value = target.value;
    const optionPosition = target.getAttribute("data-option-position");
    const optionWrapper = document.querySelector(
      `.variant-picker__option[data-option-index='${optionPosition}']`
    );
    const optionButton = optionWrapper.querySelector(
      `[data-option-selector] button[value='${value}']`
    );
    if (optionButton) {
      optionButton.click();
    }
    console.log(optionButton);
    if (document.querySelectorAll(".form-control").length > 0) {
      document.querySelectorAll(".form-control").forEach((form) => {
        const formInput = form.querySelector("input:checked");
        if (formInput) {
          form.click();
        }
      });
    }
  }
})();

const featuredCollectionlist = document.querySelectorAll(
  ".__featured_collection_scrolling"
);
for (var i = 0; i < featuredCollectionlist.length; i++) {
  featuredCollectionlist[i].setAttribute("id", "featured_collection_" + i);
}

var scrollLinks = document.querySelectorAll(".collection__nav__item a");
function smoothScrollAndRedirect(e) {
  e.preventDefault();

  var targetUrl = this.getAttribute("href");
  var targetId = targetUrl.substring(targetUrl.indexOf("#"));
  var targetElement = document.querySelector(targetId);
  window.location.href = targetUrl;
  if (targetElement) {
    setTimeout(function () {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}
scrollLinks.forEach(function (link) {
  link.addEventListener("click", smoothScrollAndRedirect);
});



setTimeout(() => {
  const klarna_popup = document.querySelector("#klarna_popup");
  if (klarna_popup) {
    klarna_popup.addEventListener("click", () => {
      const InnerPopup = document.querySelector(".product_popup");
      document.body.classList.add("klarna-overflow");
      InnerPopup.classList.add("show");
      InnerPopup.style.display = "";
      InnerPopup.querySelector(".closepopup").addEventListener("click", () => {
        document.body.classList.remove("klarna-overflow");
        InnerPopup.style.display = "none";
        InnerPopup.classList.remove("show");
      });
      InnerPopup.querySelector(".button").addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.remove("klarna-overflow");
        InnerPopup.style.display = "none";
        InnerPopup.classList.remove("show");
      });
    });
  }
}, 500);

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener('scroll', function() {
    if (window.scrollY > 10) {
        document.body.classList.add('header_stickey');
      console.log('element found');
    } else {
        document.body.classList.remove('header_stickey');
      console.log('element Not found');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  function handleAccordionClick() {
    var description = this.nextElementSibling;
    if (description.style.height === "0px" || description.style.height === "") {
      description.style.height = description.scrollHeight + "px";
      this.classList.add("activeButton");
    } else {
      description.style.height = "0px";
      this.classList.remove("activeButton");
    }
  }

  function handleResize() {
    if (window.innerWidth <= 749) {
      var headings = document.querySelectorAll(
        ".seo-section .accordion_heading"
      );
      headings.forEach(function (heading) {
        heading.removeEventListener("click", handleAccordionClick);
        heading.addEventListener("click", handleAccordionClick);
      });
    } else {
      var headings = document.querySelectorAll(
        ".seo-section .accordion_heading"
      );
      headings.forEach(function (heading) {
        heading.removeEventListener("click", handleAccordionClick);
      });
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
});

(function () {
  "use strict";

  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight;

    if (scrolled > coords) {
      goTopBtn.classList.add("back_to_top-show");
    }
    if (scrolled < coords) {
      goTopBtn.classList.remove("back_to_top-show");
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -80);
      setTimeout(backToTop, 0);
    }
  }

  var goTopBtn = document.querySelector(".back_to_top");

  window.addEventListener("scroll", trackScroll);
  goTopBtn.addEventListener("click", backToTop);
})();

const accordionItemHeaders = document.querySelectorAll(
  ".footer .footer__block--menu .footer-menu-heading"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    accordionItemHeaders.forEach((item) => {
      if (item !== accordionItemHeader) {
        item.classList.remove("active");
        item.nextElementSibling.style.maxHeight = 0;
      }
    });

    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});
var heading_title = '';
var heading_title1 = '';
if(document.querySelectorAll(".custom-main-article .article-content-wrap .prose h3").length > 0){
  heading_title = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h3");
}
if(heading_title.length > 0){  
  heading_title.forEach(function (element) {
    let text = element.textContent;
    let transformedText = text
      .toLowerCase()
      .replace(/\./g, "")               
      .replace(/\s+/g, "-")             
      .replace(/^-+/, "")               
      .replace(/-+$/, ""); 
    element.id = transformedText;
    element.setAttribute("data-located", transformedText); 
  });
}
if(document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2").length > 0){
  heading_title1 = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2");
}
if(heading_title1.length > 0){  
  heading_title1.forEach(function (element) {
    let text = element.textContent;
    let transformedText = text
      .toLowerCase()
      .replace(/\./g, "")               
      .replace(/\s+/g, "-")             
      .replace(/^-+/, "")               
      .replace(/-+$/, ""); 
    element.id = transformedText;
    element.setAttribute("data-located", transformedText); 
  });
}
// else{
//   heading_title = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2");
// }


function setupNavigationScroll() {
  const AllArticleLi = document.querySelectorAll(".article-navigation-left li");
  AllArticleLi.forEach((li) => {
    li.addEventListener("click", () => {
      const LiAttr = li.querySelector("a").getAttribute("data-href");
      const LocatedAttr = document.querySelectorAll("[data-located]");
      console.log(LiAttr);
      console.log(LocatedAttr);
      AllArticleLi.forEach((currentLi) => {
        currentLi.classList.remove("active");
      });
      li.classList.add("active");
      LocatedAttr.forEach((attr) => {
        const located_href = attr.getAttribute("id");
        // console.log("attr: ", located_href);
        // console.log("LiAttr: ", LiAttr);
        if (located_href == LiAttr) {
          var element = document.getElementById(`${located_href}`);
          var offsetTop = element.offsetTop - 100;
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setupNavigationScroll();
});

setTimeout(function () {
  setupNavigationScroll();
}, 1000);

jQuery(document).ready(function () {
  if(jQuery("#slider-for")){
    jQuery("#slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      autoplaySpeed: 2000,
      pauseOnHover: false,
    });
   } 
  });
  jQuery(document).ready(function () {
   if(jQuery(".collection_list_slider")){ 
    jQuery(".collection_list_slider").slick({
        slidesToShow: 3,
        autoSlidesToShow: true,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.4,
            slidesToScroll: 1
          }
        }
      ]
     });
    } 
  });

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}


// Add upsell product to the cart on new PDP template.
const mainProductContainer = document.querySelectorAll('.product_container_main');
if (mainProductContainer.length > 0) {
  mainProductContainer.forEach(container => {
    const toggleIcon = container.querySelector('.product-image-container');
    if (toggleIcon) {
      toggleIcon.addEventListener('click', () => {
          const productWrapper = container.closest(".product");
          const price_with_product_list = productWrapper?.querySelector('.product-list-with-price')?.classList.toggle('active');
          container.classList.toggle('active');
          const productForm = productWrapper.querySelector(".shopify-product-form");
          // const variantId = container.querySelector('[data-additional-product] [data-variant-id]').getAttribute("data-variant-id");
          if(productWrapper && productForm) {
            productForm.toggleAttribute("data-additional-product");
          }
      });
      toggleIcon.addEventListener('click', AdditionalUpsellProduct.bind(this), true);
    }
  });
}
function AdditionalUpsellProduct(event){
  setTimeout(()=>{    
    var _this = event.target;
    const closestProductInfo = _this?.closest('.product-info');
    const product_container_main = closestProductInfo?.querySelector('.product_container_main');
    const AdditionalProductData = product_container_main?.querySelector('[data-additional-product]')?.querySelector('span');
    const productInfoPrice = closestProductInfo?.querySelector('.product-info__price');
    const comparePrice = productInfoPrice?.querySelector('compare-at-price');
    const regPrice = productInfoPrice?.querySelector('sale-price');
    const productInfoBadge = productInfoPrice?.querySelector('.product-info__badge-list')?.querySelector('on-sale-badge');
    if(product_container_main.classList.contains('active')){    
      comparePrice.innerHTML = `<span class="sr-only">Regulärer Preis</span> ${AdditionalProductData?.getAttribute('data-additional-product-compare-price')}`;
      regPrice.innerHTML = `<span class="sr-only">Angebot</span> ${AdditionalProductData?.getAttribute('data-additional-product-regular-price')}`;
      productInfoBadge.innerHTML = `Sonst ${AdditionalProductData?.getAttribute('data-additional_product-saving-price')} teurer`;
    } else{
      comparePrice.innerHTML = `<span class="sr-only">Regulärer Preis</span> ${AdditionalProductData?.getAttribute('data-main-product-compare-price')}`;
      regPrice.innerHTML = `<span class="sr-only">Angebot</span> ${AdditionalProductData?.getAttribute('data-main-product-regular-price')}`; 
      productInfoBadge.innerHTML = `Sonst ${AdditionalProductData?.getAttribute('data-saving-price')} teurer`
    }
  }, 100);
}
document.addEventListener('variant:change',(evt)=>{
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  const _this = evt.target;
  const prod_info = _this?.closest('.product-info');
  const product_container_main = prod_info?.querySelector('.product_container_main');
  const additional_pro_data = product_container_main?.querySelector('[data-additional-product]')?.querySelector('span');
  const add_pro_c_price = Number(additional_pro_data?.getAttribute('data-only-add-pro-comp-price'));
  const add_pro_price = Number(additional_pro_data.getAttribute('data-only-add-pro-price'));
  const add_final_c_price = add_pro_c_price + evt.detail.variant['compare_at_price'];
  const add_final_price = add_pro_c_price + evt.detail.variant['price'];  
  const saving_price = add_final_c_price - add_final_price;
  additional_pro_data.setAttribute('data-additional-product-compare-price', formatMoney(add_final_c_price, currencyFormat));
  additional_pro_data.setAttribute('data-additional-product-regular-price', formatMoney(add_final_price, currencyFormat));
  additional_pro_data.setAttribute('data-additional_product-saving-price', formatMoney(saving_price, currencyFormat));
  additional_pro_data.setAttribute('data-main-product-compare-price', formatMoney(evt.detail.variant['compare_at_price'], currencyFormat));
  additional_pro_data.setAttribute('data-main-product-regular-price', formatMoney(evt.detail.variant['price'], currencyFormat));
  additional_pro_data.setAttribute('data-saving-price', formatMoney((evt.detail.variant['compare_at_price'] - evt.detail.variant['price']), currencyFormat));
  AdditionalUpsellProduct(evt);
})







document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more');
  const ArrowIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-md text-token-text-primary"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z" fill="currentColor"></path></svg>`

  // Count the number of text rows
  function countTextRows(textElement) {
    const computedStyle = window.getComputedStyle(textElement);
    
    const textHeight = textElement.scrollHeight;
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const numberOfRows = Math.round(textHeight / lineHeight);
    
    return numberOfRows;
  }

  function updateButtonVisibility() {
    readMoreButtons.forEach(button => {
      const content = button.closest('.item').querySelector('.content');
      const rows = countTextRows(content);

	  // Set your count of lines
      rows <= 3 ? 
		  button.classList.add('hidden') : 
	      button.classList.remove('hidden');
    });
  }


  readMoreButtons.forEach(button => {
    const content = button.closest('.item').querySelector('.content');

    button.addEventListener('click', function() {
      content.classList.toggle('expanded');
      
      content.classList.contains('expanded') ? 
        button.innerHTML = ArrowIcon : 
        button.innerHTML = ArrowIcon;
    });
  });

  updateButtonVisibility();

  window.addEventListener('resize', function() {
    updateButtonVisibility();
  });
});







jQuery(document).ready(function () {
  // Check if the screen width is less than or equal to 768px
  if (window.matchMedia("(max-width: 989px)").matches) {
    if(jQuery(".custom_timeline_slider")){
      jQuery(".custom_timeline_slider").slick({
        slidesToShow: 2, // Show one slide on mobile
        slidesToScroll: 1,
        dots: true, // Add dots for mobile navigation
        arrows: false, // No arrows
        infinite: false, // Disable infinite scrolling
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }  
  }
});









// window.setGridHeight = (selector) => {
//   const heightArray = [];
//   const offsetArray = [];
//   const sectionArray = [];
//   const diffrentHeights = [];

//   // Gather offset heights and their indices
//   document.querySelectorAll(selector).forEach((grid, i) => {
//     const offsetTop = grid.closest(`[data-equal]`)?.offsetTop || 0;
//     offsetArray.push({ index: i, offsetheight: offsetTop });
//   });

//   // Identify unique heights
//   offsetArray.forEach((e) => {
//     if (!diffrentHeights.includes(e.offsetheight)) {
//       diffrentHeights.push(e.offsetheight);
//     }
//   });

//   // Adjust each group of elements sharing the same offset height
//   diffrentHeights.forEach((height) => {
//     const data = offsetArray.filter(e => e.offsetheight === height);

//     // Gather heights and find max
//     const getAllHeightArray = data.map((ele) => {
//       const element = document.querySelectorAll(selector)[ele.index];
//       element.style.minHeight = "";  // Reset inline styles first
//       return element.offsetHeight;
//     });

//     const maxHeight = Math.max(...getAllHeightArray);

//     // Apply max height to each element in the group
//     data.forEach((ele) => {
//       document.querySelectorAll(selector)[ele.index].style.minHeight = `${maxHeight}px`;
//     });
//   });
// };

// // Run the function with the selector
// window.setGridHeight('.heading_height');


async function cartCountdownTimer(){  
  var CountDown = document.querySelectorAll('.cart_countdown-timer');

  if (CountDown.length === 0) {
    localStorage.removeItem('countdownEndTime');
    localStorage.removeItem('timerDateValue');
  } else {
    CountDown.forEach(function(count){
      if(count){
        const timerEle = count.querySelector('#countdown_cart');        
        if (!timerEle) {
          localStorage.removeItem('countdownEndTime');
          localStorage.removeItem('timerDateValue');
          return;
        }
        
        function setNewEndTime() {
          const TimerDate = timerEle.getAttribute("data-timer");
          const [minutes, seconds] = TimerDate.split(':').map(Number);
          const totalMilliseconds = (minutes * 60 * 1000) + (seconds * 1000);
          const newEndTime = new Date().getTime() + totalMilliseconds;
          
          localStorage.setItem('countdownEndTime', newEndTime);
          localStorage.setItem('timerDateValue', TimerDate);
          
          return newEndTime;
        }
  
        const currentTimerDate = timerEle.getAttribute("data-timer");
        const storedTimerDate = localStorage.getItem('timerDateValue');
        const storedEndTime = localStorage.getItem('countdownEndTime');
        
        if (!storedEndTime || !storedTimerDate || currentTimerDate !== storedTimerDate) {
          endTime = setNewEndTime();
        } else {
          endTime = parseInt(storedEndTime);
        }
      
        var x = setInterval(function() {
          if (!document.querySelector('.cart_countdown-timer')) {
            clearInterval(x);
            localStorage.removeItem('countdownEndTime');
            localStorage.removeItem('timerDateValue');
            return;
          }
  
          const currentValue = timerEle.getAttribute("data-timer");
          if (currentValue !== localStorage.getItem('timerDateValue')) {
            endTime = setNewEndTime();
          }
  
          var now = new Date().getTime();
          
          var distance = endTime - now;
          
          if (distance < 1000) {
            endTime = setNewEndTime();
            distance = endTime - now;
          }
          
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          // Add leading zeros if needed
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          
          timerEle.innerHTML = "<div>" + minutes + "</div><small>:</small><div>" + seconds + "</div>";
          
        }, 1000);
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', cartCountdownTimer);



window.setGridHeight = (selector) => {
  const heightArray = [];
  const offsetArray = [];
  const sectionArray = [];
  const differentHeights = [];

  // Gather offset heights and their indices
  document.querySelectorAll(selector).forEach((grid, i) => {
    const offsetTop = grid.closest(`[data-equal]`)?.offsetTop || 0;
    offsetArray.push({ index: i, offsetheight: offsetTop });
  });

  // Identify unique heights
  offsetArray.forEach((e) => {
    if (!differentHeights.includes(e.offsetheight)) {
      differentHeights.push(e.offsetheight);
    }
  });

  // Adjust each group of elements sharing the same offset height
  differentHeights.forEach((height) => {
    const data = offsetArray.filter(e => e.offsetheight === height);

    // Gather heights and find max
    const getAllHeightArray = data.map((ele) => {
      const element = document.querySelectorAll(selector)[ele.index];
      element.style.minHeight = "";  // Reset inline styles first
      return element.offsetHeight;
    });

    const maxHeight = Math.max(...getAllHeightArray);

    // Apply max height to each element in the group
    data.forEach((ele) => {
      document.querySelectorAll(selector)[ele.index].style.minHeight = `${maxHeight}px`;
    });
  });
};

// Run the function with the selector only on desktop
if (window.innerWidth >= 990) {
  window.setGridHeight('.heading_height');
}

// Optional: Reapply the function on window resize for dynamic responsiveness
window.addEventListener('resize', () => {
  if (window.innerWidth >= 990) {
    window.setGridHeight('.heading_height');
  } else {
    // Reset heights for smaller viewports
    document.querySelectorAll('.heading_height').forEach((element) => {
      element.style.minHeight = "";
    });
  }
});

// Product single page

// $(document).ready(function() {
//     function updateVariantDisplay() {
//         var urlVariant = new URLSearchParams(window.location.search).get('variant');
//         $('.variant-images').hide();

//         if (urlVariant) {
//             $('.variant-images').each(function() {
//                 var divId = $(this).attr('id');
//                 if (divId === urlVariant) {
//                     $(this).show();
//                 }
//             });
//         } else {
//             $('.variant-images').first().show();
//         }
//     }
//     updateVariantDisplay();
//     $(window).on('popstate', function() {
//         updateVariantDisplay();
//     });
//     setInterval(function() {
//         updateVariantDisplay();
//     }, 1000);
// });

document.addEventListener('DOMContentLoaded', function() {
    function updateVariantDisplay() {
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        const variantImages = document.querySelectorAll('.variant-images');

        variantImages.forEach(function(image) {
            image.style.display = 'none';
        });

        if (urlVariant) {
            variantImages.forEach(function(image) {
                const divId = image.getAttribute('id');
                if (divId === urlVariant) {
                    image.style.display = 'block';
                }
            });
        } else {
            if (variantImages.length > 0) {
                variantImages[0].style.display = 'block';
            }
        }
    }

    updateVariantDisplay();

    window.addEventListener('popstate', function() {
        updateVariantDisplay();
    });

    setInterval(function() {
        updateVariantDisplay();
    }, 100);
});

/* ---------- Product detail text-with-popup ---------- */

// document.addEventListener("DOMContentLoaded", function () {
//   var popupText = document.querySelector(".text-with-popup-text");
//   var popupWrapper = document.querySelector(".text-popup-con-modal-main");
//   var closePopup = document.querySelector(".close-popup");
//   var overlay = document.querySelector(".popup-overlay");
//   var body = document.body;

//   function showPopup() {
//     popupWrapper.style.display = "flex";
//     popupWrapper.style.opacity = "0";
//     setTimeout(() => {
//       popupWrapper.style.opacity = "1";
//       body.classList.add("popup-overflow-hidden");
//     }, 10);
//   }

//   function hidePopup() {
//     popupWrapper.style.opacity = "0";
//     setTimeout(() => {
//       popupWrapper.style.display = "none";
//       body.classList.remove("popup-overflow-hidden");
//     }, 300);
//   }

//   if (popupText) {
//     popupText.addEventListener("click", showPopup);
//   }
//   if (closePopup) {
//     closePopup.addEventListener("click", hidePopup);
//   }
//   if (overlay) {
//     overlay.addEventListener("click", hidePopup);
//   }
// });

window.PopupModal = function (){  
  var popupTexts = document.querySelectorAll(".text-with-popup-text");
  var popupWrappers = document.querySelectorAll(".text-popup-con-modal-main");
  var closePopups = document.querySelectorAll(".close-popup");
  var overlays = document.querySelectorAll(".popup-overlay");
  var body = document.body;

  function showPopup(popupWrapper) {
    if (!popupWrapper) return;
    popupWrapper.style.display = "flex";
    popupWrapper.style.opacity = "0";
    setTimeout(() => {
      if (popupWrapper) {
        popupWrapper.style.opacity = "1";
        body.classList.add("popup-overflow-hidden");
      }
    }, 10);
  }

  function hidePopup(popupWrapper) {
    if (!popupWrapper) return;
    popupWrapper.style.opacity = "0";
    setTimeout(() => {
      if (popupWrapper) {
        popupWrapper.style.display = "none";
        body.classList.remove("popup-overflow-hidden");
      }
    }, 300);
  }

  // Add click outside handler
  document.addEventListener('click', function(event) {
    popupWrappers.forEach(popupWrapper => {
      if (!popupWrapper) return;
      
      const popupContent = popupWrapper.querySelector('.text-popup-con-modal');
      const isClickInsidePopup = popupContent && popupContent.contains(event.target);
      const isClickOnPopupTrigger = Array.from(popupTexts).some(text => text.contains(event.target));
      
      if (popupWrapper.style.display === 'flex' && !isClickInsidePopup && !isClickOnPopupTrigger) {
        hidePopup(popupWrapper);
      }
    });
  });

  popupTexts.forEach((popupText) => {
    if (!popupText) return;
    popupText.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      const popupMain = this.closest('.text-with-popup-main');
      if (!popupMain) return;
      
      const popupIndex = popupMain.getAttribute('data-popup-target');
      if (!popupIndex) return;
      
      const popupElement = this.closest('variant-picker').querySelector(`[data-popup-index="${popupIndex}"]`);
      if (popupElement) {
        showPopup(popupElement);
      }
    });
  });

  closePopups.forEach((closePopup) => {
    if (!closePopup) return;
    closePopup.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      const popupWrapper = this.closest('.text-popup-con-modal-main');
      if (popupWrapper) {
        hidePopup(popupWrapper);
      }
    });
  });
   overlays.forEach((overlay) => {
    if (!overlay) return;
    overlay.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      const popupWrapper = this.closest('.text-popup-con-modal-main');
      if (popupWrapper) {
        hidePopup(popupWrapper);
      }
    });
  });
}

window.PopupModal();

 


window.quickBUyCustomEvent = function(){
    console.log('yesss')
    const drawers = document.querySelectorAll('quick-buy-drawer');
    
    if (drawers.length > 0) {
      const lastDrawer = drawers[drawers.length - 1];
      console.log('Last drawer found:', lastDrawer);
      
      const cartButton = lastDrawer.querySelector('.cartButton');
      
      if (cartButton) {
        const cartIconLink = document.querySelector('.header__icon-list a[aria-controls="cart-drawer"]');

        if (cartButton && cartIconLink) {
          cartButton.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default navigation
            const CartDrawerAlreadyOpen = document.querySelector('cart-drawer.cart-drawer').hasAttribute('open');
            document.querySelector('cart-drawer.cart-drawer') && CartDrawerAlreadyOpen ? document.querySelector('cart-drawer.cart-drawer').click() : cartIconLink.click();   // Trigger the cart drawer
          });
        }
      } else {
        console.error('Cart button not found in the last drawer');
      }
    } else {
      console.error('No drawers found on the page');
    }
  }


const learnBtns = document.querySelectorAll('.custom-media-with-text .learn-more-btn button.button');
if (learnBtns.length > 0) {
  learnBtns.forEach(learnBtn => {
    learnBtn.addEventListener('click', () => {
      const mainWrapper = learnBtn.closest('.custom-media-with-text');
      if (!mainWrapper) return;
      const textCon = mainWrapper.querySelector('.mobile-text-con');
      if (!textCon) return;
      textCon.classList.toggle('hidden');
      const isHidden = textCon.classList.contains('hidden');
      learnBtn.textContent = isHidden ? 'Mehr erfahren' : 'Weniger erfahren';
    });
  });
}


// window.hideDuplicate = function () {
//   const seenIds = new Set();
//   document.querySelectorAll('.js-recommendation-cart').forEach(item => {
//   const productId = item.getAttribute('product-id');
//     if (seenIds.has(productId)) {
//       item.style.display = 'none';
//       const recommendationsContainer = item.closest('product-recommendations');
//       if (recommendationsContainer) {
//         recommendationsContainer.style.display = 'none';
//       }
//     } else {
//       seenIds.add(productId);
//     }
//   }); 
// }
// window.hideDuplicate();

// ----- Hero slider button animation ------
document.addEventListener("DOMContentLoaded", () => {
  const sliderPrevBtns = document.querySelectorAll('.custom-slideshow-sec button[is="prev-button"]');
  const sliderNextBtns = document.querySelectorAll('.custom-slideshow-sec button[is="next-button"]');

  function animatePrevButton(button) {
    button.style.transform = 'translateX(50px) translateY(-50%)';
    button.style.opacity = '0';
    setTimeout(() => {
      button.style.transform = 'translateX(0) translateY(-50%)';
      button.style.opacity = '1';
    }, 150);
  }

  function animateNextButton(button) {
    button.style.transform = 'translateX(-50px) translateY(-50%)';
    button.style.opacity = '0';
    setTimeout(() => {
      button.style.transform = 'translateX(0) translateY(-50%)';
      button.style.opacity = '1';
    }, 150);
  }

  sliderPrevBtns.forEach(button => {
    button.addEventListener("click", () => animatePrevButton(button));
  });

  sliderNextBtns.forEach(button => {
    button.addEventListener("click", () => animateNextButton(button));
  });
});

// ============ CART UPSELL SLIDER JS START HERE ============== //

window.MakeSliderOnCartUpsell = function () {
const sliderElement = document.querySelector('.js-upsell__sliders[data-slider-pagination]');
const enablePagination = sliderElement?.getAttribute('data-slider-pagination') === 'true';
  if (!sliderElement) return;

  const options = {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: enablePagination,
    draggable: true,
    groupCells: false,
    freeScroll: false,
  };

  new Flickity(sliderElement, options);
};

window.MakeSliderOnCartUpsell();

// ============ CART UPSELL SLIDER JS START HERE ============== //

// ============ GA4 tracking for contact section for PDP [Email, phone & date picker] ============== //

if(document.querySelector('.contact-icons-container .section_title h2')){  

const sectionTitle = document.querySelector('.contact-icons-container .section_title h2').innerText.trim();
const contact_items = document.querySelectorAll('.contact-icon-item');
contact_items.forEach(contactItem => {
  const contactLink = contactItem.querySelector('.contact_content a[href]');  
  if (contactLink) {
    contactLink.addEventListener('click', function(event) {
      const linkItem = this.href;
      const linkLabel = this.closest('.contact_content').querySelector('p.h4').innerText.trim();      
      const linkParent = this.closest('.contact-icon-item').className || 'contact-icon-item';
      
      const dataLayerObj = {
        event: 'contact_link_click',
        section_title: sectionTitle,
        target_item: linkItem,
        target_type: linkLabel
      };
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerObj);
      console.log('DataLayer push:', dataLayerObj);
    });
  }
});
}


// ============ SEARCH bAR ADD CLASS AND REMOVE CLASS BODY CLASS ============== //

document.addEventListener('DOMContentLoaded', function () {
  
    
    // Add class to body
    document.body.classList.add('search-drawer-open');

    // Add 'open' attribute to all .search-drawer elements
    const searchDrawers = document.querySelectorAll('.search-drawer');
    searchDrawers.forEach(drawer => {
      drawer.setAttribute('open', true);
    });

  // Optional: Add click listeners to open/close the drawer
  document.querySelectorAll('.custom-search__icon').forEach(icon => {
    icon.addEventListener('click', function () {
      // document.body.classList.add('search-drawer-open');
    });
  });

  document.querySelectorAll('search-drawer button[is="close-button"]').forEach(button => {
    button.addEventListener('click', function () {
      // document.body.classList.remove('search-drawer-open');
    });
  });
  

});
// ============ SEARCH bAR ADD CLASS AND REMOVE CLASS BODY CLASS ============== //

// ============ ADD AND REMOVE CLASS IN BODY WHEN MOBILE MENU OPENS ============== //

document.addEventListener('DOMContentLoaded', function () {
    const toggleMenu = document.querySelector('.toggle-menu');
    if (toggleMenu) {
        toggleMenu.addEventListener('click', function () {
            const bodyElement = document.querySelector('body');
            if (bodyElement.classList.contains('menu-drawer-open')) {
                setTimeout(() => {
                    bodyElement.classList.remove('menu-drawer-open');
                }, 100);
            } else {
                bodyElement.classList.add('menu-drawer-open');
            }
        });
    }

    // Handle navigation drawer events
    const navigationDrawers = document.querySelectorAll('navigation-drawer');
    navigationDrawers.forEach(drawer => {
        // Listen for the dialog:after-show event
        drawer.addEventListener('dialog:after-show', function() {
            document.body.classList.add('menu-drawer-open');
        });

        // Listen for the dialog:after-hide event
        drawer.addEventListener('dialog:after-hide', function() {
            setTimeout(() => {
                document.body.classList.remove('menu-drawer-open');
            }, 100);
        });
    });
});

window.initEmptySlider = function(){
  var swiperContainer = document.querySelector(".custom-carousel__sliderwrapper");
    // Initialize Swiper instance
    var mySwiper = new Swiper(swiperContainer, {
       // slidesPerView: 3,
      slidesPerView: "auto",
      
      loop: false,
      // loopAdditionalSlides: 30,
      spaceBetween: 20,
  
    });
}
window.initEmptySlider();



document.addEventListener("DOMContentLoaded", function () {
    const searchDrawer = document.querySelector(".search-drawer");
    const input = searchDrawer.querySelector('input[type="search"]');
    const clearButton = searchDrawer.querySelector('button[type="reset"]');
    const closeButton = searchDrawer.querySelector('button[is="close-button"]');

    function focusOut(evt) {
      // Check if the click target is outside the search drawer
      if (!searchDrawer.contains(evt.target)) {
        // console.log(evt);
        searchDrawer.classList.remove("search-drawer__active");
        document.body.classList.remove("search-drawer__active");
      }
    }
    
    // Function to update class based on input value
    function updateDrawerClass() {
      // if (input.value.trim() !== "") {
      //   searchDrawer.classList.add("search-drawer__active");
      // } else {
      //   searchDrawer.classList.remove("search-drawer__active");
      // }
    }
    
    // Event: Typing in input
    input.addEventListener("input", updateDrawerClass);
    input.addEventListener("focus", (event) => {
      if(event.relatedTarget != null && event.relatedTarget.getAttribute('type') == 'reset') return;
      searchDrawer.classList.add("search-drawer__active");
      document.body.classList.add("search-drawer__active");
    });
    document.addEventListener("click", focusOut.bind(this));

    // Event: Clicking "Clear" button
    clearButton.addEventListener("click", function (event) {
      if(input.value.length > 0){
        input.value = ""; // make sure it's cleared
      }else{        
        searchDrawer.classList.remove("search-drawer__active");
        document.body.classList.remove("search-drawer__active");
        setTimeout(()=>{          
          input.blur();
        })
      }
    });

    // Event: Clicking "Close" button
    closeButton.addEventListener("click", function () {
      searchDrawer.classList.remove("search-drawer__active");
      document.body.classList.remove("search-drawer__active");
    });
  });


// Custom Comp Product Popup Js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".openPopupBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);
      if (popup) popup.classList.remove("hidden");
      document.body.classList.add('custom-popup__open');
    });
  });
  document.querySelectorAll(".closePopupBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);
      if (popup) popup.classList.add("hidden");
        document.body.classList.remove('custom-popup__open');
      });
  });
});
// Custom Comp Product Popup Js


// ============ GA4 tracking for contact section for PDP [Email, phone & date picker] ============== //

if(document.querySelector('.contact-icons-container .section_title h2')){  
const sectionTitle = document.querySelector('.contact-icons-container .section_title h2').innerText.trim();
const contact_items = document.querySelectorAll('.contact-icon-item');
contact_items.forEach(contactItem => {
  const contactLink = contactItem.querySelector('.contact_content a[href]');  
  if (contactLink) {
    contactLink.addEventListener('click', function(event) {
      const linkItem = this.href;
      const linkLabel = this.closest('.contact_content').querySelector('p.h4').innerText.trim();      
      const linkParent = this.closest('.contact-icon-item').className || 'contact-icon-item';
      
      const dataLayerObj = {
        event: 'contact_link_click',
        section_title: sectionTitle,
        target_item: linkItem,
        target_type: linkLabel
      };
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerObj);
      console.log('DataLayer push:', dataLayerObj);
    });
  }
});
}

// js/common/utilities/format-money.js
function customFormatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// Update Main Price with quantity break price
window.updateQuantityBreaksPrice = function(quantityEle){
  setTimeout(()=>{
    const mainProductEle = document.querySelector('safe-sticky');
    if(mainProductEle){
      const salePriceEle = mainProductEle.querySelector('sale-price');
      const price_break_main_ele = mainProductEle.querySelector('.price-quantity-break');
      if(price_break_main_ele){
        var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
        const price_break_data = price_break_main_ele.querySelector('.quantity-price-breaks-data');
        const parseJsonData = JSON.parse(price_break_data.textContent);
        const currentQuantity = Number(quantityEle.value);
        // console.log(parseJsonData);
        parseJsonData.sort((a, b) => a.quantity - b.quantity);
        let selectedTier = parseJsonData[0]; // default to the lowest tier
        let updatedPrice = parseJsonData[0].price;
        for (let i = 0; i < parseJsonData.length; i++) {
          if (currentQuantity >= parseJsonData[i].quantity) {
            selectedTier = parseJsonData[i];
            updatedPrice = selectedTier.price;
          } else {
            break;
          }
        }
        if(salePriceEle){
          salePriceEle.lastChild.replaceWith(document.createRange().createContextualFragment(customFormatMoney(updatedPrice, currencyFormat)));
        }
        // console.log(customFormatMoney(updatedPrice, currencyFormat));
      }
    }
  }, 300)
}